var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form__field-holder",
      class: { "form__field-holder_error": !!_vm.errors.has(_vm.newName) },
      attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label }
    },
    [
      _c("div", { staticClass: "form__field-box" }, [
        _vm.label
          ? _c("label", { staticClass: "form__label" }, [
              _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { class: { "form__extra-info": _vm.IsExtraInfo } },
          [
            _c("vue-numeric", {
              staticClass: "form__textfield",
              attrs: {
                minus: true,
                name: _vm.name,
                precision: _vm.precision,
                "thousand-separator": "",
                "decimal-separator": ","
              },
              on: {
                change: function($event) {
                  return _vm.$emit("change", $event)
                },
                blur: function($event) {
                  return _vm.$emit("blur", $event)
                }
              },
              model: {
                value: _vm.model,
                callback: function($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            }),
            _vm._v(" "),
            [
              _c(
                "div",
                { staticClass: "form__extra-info__content" },
                [_vm._t("extra-info")],
                2
              )
            ]
          ],
          2
        ),
        _vm._v(" "),
        _vm.errors.has(_vm.newName)
          ? _c("div", { staticClass: "form__field-error" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.errors.first(_vm.newName)) + "\n    "
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1695a3f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1695a3f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VNumericFieldPublic.vue
// module id = 475
// module chunks = 1